<template>
  <div
    class="h-fill max-h-[1164px] xl:max-h-[590px] 4xl:max-h-[1000px] 5xl:max-h-[1018px] [rounded-[8px] bg-white shadow-[0_4px_8px_0_rgba(215,227,235,0.25)] flex flex-col"
  >
    <!-- Header -->
    <div class="border-none pt-[20px] pb-[10px] text-center">
      <h5
        class="text-[#000] font-['Poppins',sans-serif] text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] font-semibold leading-normal"
      >
        Event Log
      </h5>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-auto px-[28px] mb-[20px] custom-scrollbar">
      <div class="flex flex-col">
        <div
          v-for="(val, i) in eventList"
          :key="i"
          class="w-full"
        >
          <!-- Date label -->
          <div
            class="flex items-center justify-start text-[#218863] font-['Poppins',sans-serif] text-[16px] 4xl:!text-[20px] 5xl:!text-[28px] font-semibold leading-[23px] mt-[22px] mb-[12px] 5xl:mb-[26px] w-full"
          >
            {{ formatDate(val.date) }}
            <span
              class="flex-auto ml-[3px] h-[1px] bg-gradient-to-r from-[#218863] to-[rgba(191,191,191,0)]"
            ></span>
          </div>

          <!-- Event logs -->
          <div
            v-for="(event, index) in val.items"
            :key="index"
            class="w-full"
          >
            <div
              class="text-[#ababab] font-['Poppins',sans-serif] text-[16px] 4xl:!text-[20px] 5xl:!text-[28px] font-normal leading-[23px] 4xl:!leading-[30px] 5xl:!leading-[36px] my-[11px] 5xl:my-[18px]"
            >
              <strong
                class="text-[#ababab] font-['Poppins',sans-serif] text-[16px] 4xl:!text-[20px] 5xl:!text-[28px] font-semibold leading-[23px]"
              >
                [{{ event.time }} |
                <span :style="event.methodColor">{{ event.methods }}</span>]
              </strong>
              {{ event.log }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    eventLogs: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    eventList() {
      if (!Array.isArray(this.eventLogs)) return [];

      return this.eventLogs.reduce((acc, log) => {
        if (!log.date) return acc;

        let dateGroup = acc.find((group) => group.date === log.date);
        if (!dateGroup) {
          dateGroup = {
            date: log.date,
            items: [],
          };
          acc.push(dateGroup);
        }

        dateGroup.items.push({
          time: log.time || "",
          log: log.log || "",
          methods: log.methods || "",
          methodColor:
            log.methods?.toUpperCase() === "AUTO"
              ? "color: #2A5CAA"
              : "color: #218863;",
        });

        return acc;
      }, []);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      const today = moment(date).isSame(moment(), "day");
      return today ? "Today" : moment(date).format("DD MMMM YYYY");
    },
  },
};
</script>